import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=456aa58c&scoped=true&"
import script from "./Dashboard.vue?vue&type=script&lang=js&"
export * from "./Dashboard.vue?vue&type=script&lang=js&"
import style0 from "./Dashboard.vue?vue&type=style&index=0&id=456aa58c&prod&lang=sass&"
import style1 from "./Dashboard.vue?vue&type=style&index=1&id=456aa58c&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456aa58c",
  null
  
)

export default component.exports